import { Singleton } from '@visiba/instantiation';
import { HostingService } from './_hosting.service';
import { PlatformService, _BrowserList } from './_platform.service';

@Singleton()
export class EnvironmentService {
	// prettier-ignore
	constructor(
		public readonly platform: PlatformService,
		public readonly hosting: HostingService,
	) {
		// Empty
	}
}

export { _BrowserList as BrowserList };
